module.exports = function() {
  return new Worker(__webpack_public_path__ + "7be5e8cc7b6d88fe1e40.worker.js");
};